import {AuthToken} from '@github-ui/copilot-auth-token/auth-token'
import {getAgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'

type InitialAuthToken = {token: string; expiration: string; ssoOrgIDs?: string[]}

/**
 * Rails supplies a CAPI-encrypted token even when the gateway flag makes CMC the default provider.
 * Saving it in the default provider's CMC cache would make CMC reuse a token it cannot decrypt
 * instead of fetching its own.
 *
 * Update the default provider's SSO organization IDs first: the CAPI-pinned getter copies them.
 * Then seed only the CAPI cache, leaving CMC to fetch and cache its own token.
 */
export function useInitializeAuthToken(initialAuthToken: InitialAuthToken | undefined): void {
  if (!initialAuthToken) return

  const defaultTokenProvider = getAgentSessionsTokenProvider()
  defaultTokenProvider.ssoOrgIDs = initialAuthToken.ssoOrgIDs ?? []

  const capiTokenProvider = getAgentSessionsTokenProvider(true)
  const existingToken = capiTokenProvider.getLocalStorageAuthToken()

  const shouldUseSSRToken = !existingToken || existingToken.isExpired || existingToken.value !== initialAuthToken.token

  if (shouldUseSSRToken) {
    const token = new AuthToken(initialAuthToken.token, initialAuthToken.expiration, initialAuthToken.ssoOrgIDs ?? [])
    capiTokenProvider.setLocalStorageAuthToken(token)
  }
}
